import React, { useState } from 'react';

import OTP from '../../components/OTP';
import ResendOTP from '../../components/ResendOTP';
import styles from './otpStep.module.scss';
import { CONSTANTS } from '../../constants';

export function OtpStep(props) {
  const {
    phoneNumber,
    isLoading,
    onOTPResend,
    onOTPSubmit,
    initialTime = 60,
  } = props;
  const [resetOtpComponent, setResetOtpComponent] = useState(false);
  const [resendingOTP, setResendingOTP] = useState(false);
  const [otpHasBeenResent, setOtpHasBeenResent] = useState(false);
  const [currentTime, setCurrentTime] = useState(initialTime);
  const [otp, setOtp] = useState('');

  const handleSubmit = () => {
    onOTPSubmit(otp);
    setOtp('');
    // force otp component to rerender to reset it states
    setResetOtpComponent((prevState) => !prevState);
  };

  const handleOTPResend = async () => {
    setResendingOTP(true);
    const success = await onOTPResend();
    if (success) {
      setOtpHasBeenResent(true);
      setTimeout(() => {
        setCurrentTime(initialTime);
        setOtpHasBeenResent(false);
      }, 3000);
    }
    setResendingOTP(false);
  };

  return (
    <div className={styles['otp-step']}>
      {(resendingOTP || otpHasBeenResent) && (
        <div className={styles['otp-message-container']}>
          <div className="halan_loader_two" />
          {resendingOTP && (
            <p className={styles['otp-message']}>
              {CONSTANTS.OTP.AWAITING_RESPONSE}
            </p>
          )}
          {otpHasBeenResent && (
            <p className={styles['otp-message']}>
              {CONSTANTS.OTP.OTP_SENT_SUCCESS}
            </p>
          )}
        </div>
      )}

      {!(resendingOTP || otpHasBeenResent) && (
        <div className={styles['otp-step-container']}>
          <div className={styles['hint']}>
            <h3>{CONSTANTS.OTP.DIGIT_CODE()}</h3>
            <p>{CONSTANTS.OTP.ENTER_CODE(phoneNumber)}</p>
          </div>

          <div className={styles['otp-container']} data-loading={isLoading}>
            <OTP
              key={resetOtpComponent.toString()}
              length={6}
              onComplete={(otp) => setOtp(otp)}
            />
            <div className={styles['resend-otp-msg']}>
              <ResendOTP
                currentTime={currentTime}
                setCurrentTime={setCurrentTime}
                onSubmit={handleOTPResend}
              />
            </div>
          </div>
        </div>
      )}

      <button
        onClick={handleSubmit}
        disabled={!otp || isLoading || otpHasBeenResent}
        className={`halan_btn halan_btn_main ${
          isLoading ? 'halan_btn_loading' : ''
        }`}
      >
        {!isLoading && CONSTANTS.OTP.BTN}
        {isLoading && <div className="halan_loader" />}
      </button>
    </div>
  );
}

export default OtpStep;
